import { createFileRoute } from "@tanstack/react-router";

/**
 * Customer Fleet Overview index route (CLA-469).
 *
 * Eagerly registers the `/clawinstall/dashboard/` file route; the overview page
 * component is deferred to `index.lazy.tsx` so its chunk stays out of the main
 * bundle.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/dashboard/")({});
